// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__jVCTZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__11dUE"};